import React from 'react';
import { SelectConnection } from 'new/elements/flows/SelectConnection';
import { FCFormPageType, useForm } from 'new/elements/Form/useForm';
import flowTypes from 'new/components/flows/types/flowTypes';
import useConnectionsPage from 'new/components/flows/controller/useConnectionsPage';
import useCDC from 'new/components/flows/types/cdc/CreateCDCFlow/CDCFlow/useCDC';

interface SelectConnectionPageProps {}

export const SelectConnectionPage: FCFormPageType<SelectConnectionPageProps> = (
  props: SelectConnectionPageProps,
) => {
  const { nextPage } = useForm();
  const { connectionType, selectedConnection, onSelectConnection } = useCDC();
  useConnectionsPage(selectedConnection);

  const onConnectionSelected = (selectedConnection) => {
    onSelectConnection(selectedConnection);
    nextPage(null, true);
  };

  return (
    <SelectConnection
      flowType={flowTypes.cdc}
      connectionType={connectionType}
      selectedConnection={selectedConnection}
      onConnectionSelected={onConnectionSelected}
    />
  );
};

SelectConnectionPage.formConfig = {
  title: 'Connect',
};
